import React, { useEffect, useEffectEvent } from "react";

function padTime(number) {
  const absolute = Math.abs(number);
  return absolute < 99
    ? ("00" + absolute.toString()).slice(-2)
    : number.toString();
}

function CountdownTimer({
  message = "Time remaining to complete payment:",
  onTimeout,
  reset = null,
  timeout,
  timeoutMessage = "Time to pay has elapsed, your registration has been cancelled.",
}) {
  const [state, setState] = React.useState(() => ({
    seconds_elapsed: 0,
    start_time: Math.floor(Date.now() / 1000),
    submitting: false,
    timed_out: false,
  }));
  const notifyTimeout = useEffectEvent(() => {
    onTimeout?.();
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setState((current) => {
        if (current.seconds_elapsed >= timeout) return current;
        let elapsed = Math.floor(Date.now() / 1000) - current.start_time;
        if (elapsed - current.seconds_elapsed <= 0) {
          elapsed = current.seconds_elapsed + 1;
        }
        return {
          ...current,
          seconds_elapsed: Math.min(elapsed, timeout),
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [timeout]);

  useEffect(() => {
    if (state.timed_out || state.seconds_elapsed < timeout) return;
    setState((current) => ({
      ...current,
      timed_out: true,
      seconds_elapsed: timeout,
    }));
    notifyTimeout();
  }, [state.seconds_elapsed, state.timed_out, timeout]);

  function handleReset(event) {
    setState((current) => ({ ...current, submitting: true }));
    return reset?.(event) ?? false;
  }

  const remaining = Math.max(0, timeout - state.seconds_elapsed);
  const formattedTime =
    padTime(Math.floor(remaining / 3600)) +
    ":" +
    padTime(Math.floor(remaining / 60)) +
    ":" +
    padTime(remaining % 60);

  return (
    <div className="TimeoutCounter">
      {message} <strong>{formattedTime}</strong>
      {state.timed_out ? (
        <div className="TimeoutConfirm">
          <div className="TimeoutMessage">{timeoutMessage}</div>
          {reset ? (
            <button
              className="ui button red"
              onClick={handleReset}
              disabled={state.submitting}
            >
              {state.submitting ? "Resetting ..." : "Try Again"}
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

export default CountdownTimer;
